(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  function gridlistview(){
    const buttonpreview = document.querySelectorAll('.preview');

    if(document.getElementById('ProductGridContainer')){  
      // console.log("grid");
      var gridorlistview = "gridorlistview";
      // console.log(sessionStorage.getItem(gridorlistview));
     if(sessionStorage.getItem(gridorlistview) == null){
        sessionStorage.setItem(gridorlistview, "grid");
        document.getElementById('ProductGridContainer').classList.replace("list_view","grid_view");        
      } else {
          gridorlistview = sessionStorage.getItem(gridorlistview);
        if(gridorlistview == "grid"){
            document.querySelectorAll('#prd_list').forEach((item) => {
                  item.classList.remove("active");
                });
                // document.getElementById('prd_list').classList.replace("active","inactive");
                document.getElementById('ProductGridContainer').classList.replace("list_view","grid_view");
                 sessionStorage.setItem(gridorlistview, "grid");
        } else {
             // console.log(document.getElementById('prd_grid').classList);
             document.querySelectorAll('#prd_grid').forEach((item) => {
              item.classList.remove("active");
            });           

            // document.getElementById('prd_grid').classList.replace("active","inactive");
            document.getElementById('ProductGridContainer').classList.replace("grid_view","list_view");
            sessionStorage.setItem(gridorlistview, "list");
        }
      }
    }
      var i;
      for (i = 0; i < buttonpreview.length; i++) {
        buttonpreview[i].onclick = function(){
           var gridorlistview = "gridorlistview";
          if(this.dataset.view == 'grid'){
            this.classList.add('active');
            
            document.querySelectorAll('#prd_list').forEach((item) => {
              item.classList.remove("active");
            });
            // document.getElementById('prd_list').classList.replace("active","inactive");
            document.getElementById('ProductGridContainer').classList.replace("list_view","grid_view");
             sessionStorage.setItem(gridorlistview, "grid");
          }
          if(this.dataset.view == 'list'){
            this.classList.add('active');
            // console.log(document.getElementById('prd_grid').classList);
             document.querySelectorAll('#prd_grid').forEach((item) => {
              item.classList.remove("active");
            });           

            // document.getElementById('prd_grid').classList.replace("active","inactive");
            document.getElementById('ProductGridContainer').classList.replace("grid_view","list_view");
            sessionStorage.setItem(gridorlistview, "list");
          }
                              
          // Create a GridViewListView event
          var event;
          if (typeof(window.CustomEvent) === 'function') {
            event = new CustomEvent('GridViewListView', {
              bubbles: true
            });
          } else {
            event = document.createEvent('CustomEvent');
            event.initCustomEvent('GridViewListView', true, false, null);
          }

          // Dispatch the render event
          document.dispatchEvent(event);          
        }
      } 
      
    // console.log(document.getElementById('ProductGridContainer').classList);
    if(document.getElementById('ProductGridContainer')){
      if(document.getElementById('ProductGridContainer').classList.contains('list_view')){
        document.querySelectorAll('#prd_grid').forEach((item) => {
          item.classList.remove("active");
        });
        document.querySelectorAll('#prd_list').forEach((item) => {
          item.classList.add('active');
        });
      }
    }    
  }
  gridlistview();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stockist"] && !window.DesignMode) return;
  try {
    
  document.getElementById('searchButton').addEventListener('click', function() {
    var query = document.getElementById('searchInput').value.toLowerCase();
    var stockistItems = document.querySelectorAll('.stockist-item');
    var noResultsMessage = document.getElementById('noResultsMessage');
    var found = false;

    stockistItems.forEach(function(item) {
      var address = item.getAttribute('data-address');
      if (address.includes(query)) {
        item.style.display = '';
        found = true;
      } else {
        item.style.display = 'none';
      }
    });

    // Display message if no results are found
    if (!found) {
      noResultsMessage.style.display = 'block';
    } else {
      noResultsMessage.style.display = 'none';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usps-section"] && !window.DesignMode) return;
  try {
    
  function initializeSlickSlider() {
    // Check if the viewport width is 749px or less
    if (window.innerWidth <= 749) {
      // Ensure the slider isn't already initialized
      if (!$('.mySlider').hasClass('slick-initialized')) {
        $('.mySlider').slick({
          dots: false,
          arrows: false,
          infinite: false,
          speed: 300,
          responsive: [
            {
              breakpoint: 750,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 5000,
              }
            }
          ]
        });
      }
    } else {
      // If the slider is initialized and not in mobile view, destroy it
      if ($('.mySlider').hasClass('slick-initialized')) {
        $('.mySlider').slick('unslick');
      }
    }
  }

  // Run the function on DOMContentLoaded and on window resize
  document.addEventListener("DOMContentLoaded", initializeSlickSlider);
  window.addEventListener("resize", initializeSlickSlider);

  } catch(e) { console.error(e); }
})();
})();
